/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
const EXPLANATION_OPTIONS = Object.freeze({
  NO_PHONE: {
    name: 'NO_PHONE',
    translationKey: 'two_factor.mandatory_exemption.explanation.no_phone'
  },
  RELIABILITY_CONCERN: {
    name: 'RELIABILITY_CONCERN',
    translationKey: 'two_factor.mandatory_exemption.explanation.reliability_concern'
  },
  NEED_SETUP_HELP: {
    name: 'NEED_SETUP_HELP',
    translationKey: 'two_factor.mandatory_exemption.explanation.need_setup_help'
  },
  NEED_STAFF_TRAINING: {
    name: 'NEED_STAFF_TRAINING',
    translationKey: 'two_factor.mandatory_exemption.explanation.need_staff_training'
  },
  SHARED_ACCOUNT: {
    name: 'SHARED_ACCOUNT',
    translationKey: 'two_factor.mandatory_exemption.explanation.shared_account'
  },
  OTHER: {
    name: 'OTHER',
    translationKey: 'two_factor.mandatory_exemption.explanation.other'
  }
});
let TwoFactorMandatoryExemptionBaseComponent = (_dec = service('ember-multipassfe-client'), _dec2 = service('ember-multipass-logging'), (_class = class TwoFactorMandatoryExemptionBaseComponent extends Component {
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get canSubmit() {
    return !this.invalidReason && !this.invalidInfo && !this.invalidTerms;
  }
  get explanation() {
    let fullExplanation = this.explanationOption;
    if (this.explanationText) {
      fullExplanation = `${fullExplanation} - ${this.explanationText}`;
    }
    return fullExplanation;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "acknowledge", _descriptor5, this);
    _initializerDefineProperty(this, "time", _descriptor6, this);
    _initializerDefineProperty(this, "explanationOption", _descriptor7, this);
    _initializerDefineProperty(this, "explanationText", _descriptor8, this);
    _initializerDefineProperty(this, "loading", _descriptor9, this);
    _initializerDefineProperty(this, "exemptionGrantedModalOpen", _descriptor10, this);
    _initializerDefineProperty(this, "invalidReason", _descriptor11, this);
    _initializerDefineProperty(this, "invalidInfo", _descriptor12, this);
    _initializerDefineProperty(this, "invalidTerms", _descriptor13, this);
    _defineProperty(this, "explanationOptions", EXPLANATION_OPTIONS);
  }
  updateAcknowledge(evt) {
    this.acknowledge = evt.detail.current;
    if (this.invalidTerms) {
      this.invalidTerms = !this.acknowledge;
    }
  }
  updateTimeRequested(evt) {
    this.time = parseInt(evt.target.value);
  }
  updateExplanation(evt) {
    this.explanationText = evt.target.value;
    if (this.invalidInfo) {
      this.invalidInfo = !this.explanationText;
    }
  }
  redirect() {
    this.multipassfeClient.redirect();
  }
  handleExplanationOptionChange(e) {
    this.explanationOption = e.detail.newSelectionValue;
    this.invalidReason = !this.explanationOption;
    this.invalidInfo = this.explanationOption === EXPLANATION_OPTIONS.OTHER.name && !this.explanationText;
  }
  validateForm() {
    this.invalidTerms = !this.acknowledge;
    this.invalidReason = !this.explanationOption;
    this.invalidInfo = this.explanationOption === EXPLANATION_OPTIONS.OTHER.name && !this.explanationText;
  }
  async submitDebounced() {
    debounce(this, this.submit, 500, true);
  }
  async submit() {
    this.validateForm();
    if (this.loading || !this.canSubmit) {
      return;
    }
    try {
      this.loading = true;
      const data = {
        requested_duration_days: this.time,
        reason: this.explanation
      };
      await this.multipassfeClient.createMandatoryTwoFactorException(data);
      this.exemptionGrantedModalOpen = true;
    } catch (e) {
      this.logger.error('Error creating mandatory 2fa exception', e.message);
      let errorText = this.intl.t(`${this.tPrefix}two_factor.mandatory_exemption.errors.unknown`);
      if (e.message === 'TEMPORARY_LOCKOUT') {
        errorText = this.intl.t(`${this.tPrefix}two_factor.mandatory_exemption.generic.try_again_later`);
      }
      this.marketToasts.critical(errorText);
    } finally {
      this.loading = false;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "acknowledge", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "time", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 30;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "explanationOption", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "explanationText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "exemptionGrantedModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "invalidReason", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "invalidInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "invalidTerms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateAcknowledge", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAcknowledge"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTimeRequested", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTimeRequested"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateExplanation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateExplanation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "redirect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "redirect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleExplanationOptionChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleExplanationOptionChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateForm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validateForm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype)), _class));
export { TwoFactorMandatoryExemptionBaseComponent as default };